@if (title) {
  <h1 class="td-wb-plan-summary__title"
      id="td-wb-aria-plan-summary-title"
      translate="tdWb.lti.summary.PLAN"></h1>
}
<h2 class="td-wb-plan-summary__header"
    aria-live="assertive">
  @if (showSavings) {
    <span>
      <span
        [innerHTML]="'tdWb.lti.summary.'+ subType | translate:{targetAmount: targetAmount | tdWbCurrency: {format:'c0'}, superScript: superScript}">
      </span>&nbsp;
    </span>
  } @else {
    <span translate="tdWb.lti.summary.GROW_YOUR_MONEY"></span>&nbsp;
  }
  @if (showSavingPlanDescription()) {
    <span>
      <span
        [innerHTML]="'tdWb.lti.summary.SAVINGS_PLAN' | translate:{projectedAmount: projectedAmount | tdWbCurrency: {format:'c0'}, superScript: superScript}"></span>
    </span>
  }
</h2>
